module.exports = __webpack_public_path__ + "static/media/1.32c8ef53.jpg";